import React from "react";
import { Helmet } from "react-helmet-async";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/HeroSection/Hero";
import Contact from "../../components/Contact/ContactForm";

import HeroImage from "../../assets/images/white-blue.png";

import "./faq.css";

function FAQ() {
  return (
    <div>
      <Helmet>
        <title>FAQ's</title>
      </Helmet>

      <Header />

      <HeroSection
        backgroundImage={HeroImage}
        title="Got questions for us?"
        subtitle="We're here to help!"
        dividerPath="M0,160L48,170.7C96,181,192,203,288,229.3C384,256,480,288,576,298.7C672,309,768,299,864,288C960,277,1056,267,1152,250.7C1248,235,1344,213,1392,202.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        dividerColour="white"
      />
      <div className="FaqContainer">
        <div className="FaqSection">
          <h2>FAQ's</h2>
          <div className="Question">
            <h3>
              <strong>Q.</strong> How does a slush machine work?
            </h3>
            <p>
              <strong>A.</strong> Slush machines work by mixing ice, syrup, and
              air to create a frozen, slushy texture. The machine uses a
              refrigerated barrel that continuously churns the mixture, keeping
              it smooth and consistent. As the machine freezes the ingredients,
              it dispenses the slush in the desired texture and flavor.
            </p>
            <a href="https://www.youtube.com/watch?v=UgfACPnSziI">
              Watch the video to see it in action!
            </a>
          </div>

          <div className="Question">
            <h3>
              <strong>Q.</strong> How do I operate a slush machine?
            </h3>
            <p>
              <strong>A.</strong> Operating a slush machine is simple. Begin by
              ensuring the machine is plugged in and properly set up. Add your
              slush mix and water to the machine, making sure to follow the
              instructions for the correct proportions. Turn on the machine,
              adjust the settings if needed, and allow it to churn until the
              slush reaches the desired consistency.
            </p>
            <a href="https://www.youtube.com/watch?v=XEpZuwW904o&t=1s">
              Watch the video for a step-by-step for the Elmeco First Class!
            </a>
            <br></br>
            <a href="https://www.youtube.com/watch?v=K6Acot9nM8k">
              Watch this video for a step-by-step for the Elmco Big Biz
            </a>
          </div>

          <div className="Question">
            <h3>
              <strong>Q.</strong> How do I clean a slush machine?
            </h3>
            <p>
              <strong>A.</strong> Cleaning your slush machine is essential to
              maintain performance and hygiene. Start by turning off the machine
              and unplugging it. Remove any remaining slush and ice, and
              disassemble any parts that are removable, such as the hopper and
              dispensing spout. Clean these parts with warm water and a mild
              detergent, then rinse thoroughly. For the internal components, use
              a damp cloth to wipe down the surfaces, making sure no syrup
              residue is left.
            </p>
            <a href="https://www.youtube.com/watch?v=nnRoEflr8qU">
              Watch the cleaning process in this video!
            </a>
          </div>

          <div className="Question">
            <h3>
              <strong>Q.</strong> What should I do if my slush machine isn't
              freezing?
            </h3>
            <p>
              <strong>A.</strong> If your slush machine isn't freezing, check
              the power supply - extension leads and multi plug boards could be
              an issue. Check that the air flow is sufficient and the vents are
              not blocked by obstruction or dust. Ensure the mix has the correct
              syrup-to-water ratio and that the machine's cooling system is
              working by pushing the reset button (if your machine has one).
              Also, check the fan is running.
            </p>
            {/* <a href="">Watch the troubleshooting video!</a> */}
          </div>

          <div className="Question">
            <h3>
              <strong>Q.</strong> How do I find the reset button on my slush
              machine?
            </h3>
            <p>
              <strong>A.</strong> If your slush machine stops working or
              experiences an error, it may need a reset. The reset button is
              typically located near the control panel or on the back of the
              machine. Press it once, wait for the machine to reboot, and check
              if it's operating normally again.
            </p>
            <a href="https://www.youtube.com/watch?v=cNIoqvq3R8A">
              Watch how to find and reset the button!
            </a>
          </div>

          <div className="Question">
            <h3>
              <strong>Q.</strong> Who invented the slush machine?
            </h3>
            <p>
              <strong>A.</strong> The slush machine was invented in 1961 by
              Salvatore Cortese, founder of the Elmeco and inventor of the first
              slush machine
            </p>
            <a href="https://www.elmeco.com/en/history/">
              Read more about the history of slush machines here!
            </a>
          </div>
        </div>
      </div>

      <div className="HomeContactContainer" style={{ padding: "0%" }}>
        <div className="HomeContactTitle">
          <h2>Got any more questions?</h2>
          <p>Let us know!</p>
        </div>

        <Contact />
      </div>

      <Footer />
    </div>
  );
}

export default FAQ;
